import STRINGS from "./strings.json";
import { writable } from "svelte/store";

export const lang = writable("nl");

lang.subscribe((value) => {
  if (value !== "nl" && value !== "fr" && value !== "en") {
    console.error(`Language code ${lang} is invalid. Only "nl", "fr" and "en" are supported.`);
  }
});

function replace(str, replacements) {
  for (const key in replacements) {
    str = str.replace(new RegExp(`{{ ${key} }}`, "g"), replacements[key]);
  }
  return str;
}

export function t(key, lang, replacements = {}) {
  let string = STRINGS[key];
  if (!string) {
    console.error(`Could not find string for key ${key}`);
    return `{{ ${key} }}`;
  }
  string = string[lang];
  string = replace(string, replacements);
  return string;
}
